import ReportDemographicsContainer from './report_demographics_container';

const ReportDemographics = ReportDemographicsContainer;
export default ReportDemographics;
